// Header scroll blur effect - activates when scrolling past hero section
document.addEventListener('DOMContentLoaded', function() {
  const announcementWrapper = document.querySelector('.announcement-bar-section');
  const sectionHeader = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  const stickyHeader = document.querySelector('sticky-header');
  const mainHeader = document.querySelector('#shopify-section-header');
  const heroSection = document.querySelector('.suvee-hero');

  if (!heroSection) return;

  function updateHeaderBlur() {    
    const offsetTopValue = parseInt(window.getComputedStyle(heroSection).paddingTop, 10) - announcementWrapper.offsetHeight - headerWrapper.offsetHeight;    

    const scrollPosition = window.scrollY; // Account for header height (44px + 76px)

    if (scrollPosition > offsetTopValue) {
      // Add blur when scrolled past hero
      if (announcementWrapper) announcementWrapper.classList.add('header-scrolled');
      if (sectionHeader) sectionHeader.classList.add('header-scrolled');
      if (headerWrapper) headerWrapper.classList.add('header-scrolled');
      if (stickyHeader) stickyHeader.classList.add('header-scrolled');
      if (mainHeader) mainHeader.classList.add('header-scrolled');
    } else {
      // Remove blur when at top
      if (announcementWrapper) announcementWrapper.classList.remove('header-scrolled');
      if (sectionHeader) sectionHeader.classList.remove('header-scrolled');
      if (headerWrapper) headerWrapper.classList.remove('header-scrolled');
      if (stickyHeader) stickyHeader.classList.remove('header-scrolled');
      if (mainHeader) mainHeader.classList.remove('header-scrolled');
    }
  }

  // Check on scroll
  window.addEventListener('scroll', updateHeaderBlur);

  // Check on load
  updateHeaderBlur();

  // Check on resize (hero height might change)
  window.addEventListener('resize', updateHeaderBlur);
});